/**
	TY rating component. Include ty-rating-2.js and ty-rating-2.css in your page.
	Usage:

		$("#overallrating").tyRating({
			maxValue: 5,
		 	initValue: 5,
			readOnly: false,
		 	selectedCallback:
		 		function(selectedRating) {
					if (selectedRating) {
						window.alert("selected!");
					} else {
						window.alert("unselected!");
					}
				}
		});

	Note: for 5 points scale we temporarily display old rating component
 */

(function($){

	var defaultSettings = {
		maxValue: 5,
		initValue: null,
		selectedCallback: $.noop,
		readOnly: false,
        ratingClasses: {
            neg: 'rating-neg',
            neu: 'rating-neu',
            pos: 'rating-pos',
            na: 'rating-none'
        },
		ratingMsgs: {
			'1': 'Inadequate',
			'2': 'Inadequate',
			'3': 'Adequate',
			'4': 'Adequate',
			'5': 'Satisfactory',
			'6': 'Satisfactory',
			'7': 'Good',
			'8': 'Very good',
			'9': 'Excellent',
			'10': 'Excellent'
		},
		ratingNumbers: {
			'zero':'0',
			'1': 'one',
			'2': 'two',
			'3': 'three',
			'4': 'four',
			'5': 'five',
			'6': 'six',
			'7': 'seven',
			'8': 'eight',
			'9': 'nine',
			'10': 'ten'
		},
		numbersDict:{
			zero:'0',
			one:'1',
			two: '2',
			three: '3',
			four: '4',
			five: '5',
			six: '6',
			seven: '7',
			eight: '8',
			nine: '9',
			ten: '10'
		},
        clickHereMsg: "Rate here",

		// needed for backwards compatibility
		showNotApplicable: false,
		notApplicableLongMsg: '@Not applicable',
		notApplicableShortMsg: '@N/A'
	};

	var getRatingSentiment = function(rating, maxValue) {
		if (rating === -1){
			return 'na';
		} else if (rating <= Math.ceil(maxValue / 3)) {
			return 'neg';
		} else if (rating > maxValue - Math.ceil(maxValue / 3)) {
			return 'pos';
		} else {
			return 'neu';
		}
	};

    var generateClasses = function(maxValue, ratingClasses, componentColors) {

        var classes = {};
        var ratingSentiment;
        for (var i = 1; i <= maxValue; i++) {
        	if(componentColors && componentColors[i]) {
             	ratingSentiment = componentColors[i];
        	}
        	else {
        		ratingSentiment = getRatingSentiment(i, maxValue);
        	}

            classes[String(i)] = ratingClasses[ratingSentiment];
        }

        classes[String(-1)] = ratingClasses[getRatingSentiment(-1, maxValue)];

        return classes;
    };

	var generateContent = function(element,settings) {

		element.empty();
		var content = $('<div></div>').addClass('rating rating-score').attr('data-scale', settings.maxValue);
		if (settings.maxValue === 5){
			content.addClass('branded');
		}
		element.append(content);
		//Adding N/A option if enabled
		if(settings.showNotApplicable){
			content.prepend(
				$('<label class="not-applicable">' +
					'<i class="ty-icon ty-icon-checkbox"></i> ' +
					settings.notApplicableLongMsg +
				'</label>')
				.attr('data-value', '-1')
			);
		}

		var rating = $('<ul></ul>').addClass('rating-buttons');

		for (var currValue = 1; currValue <= settings.maxValue; currValue++) {
			rating.append(
				$('<li></li>').attr('data-value', currValue).html(settings.numbersDict[settings.ratingNumbers[String(currValue)]])
			);
		}
		content.append(rating);

		content.append(
			$('<a></a>').addClass('rating-label rating-label-max').html(settings.clickHereMsg)
		);
	};

	function activateContent(element, initValue, maxValue, readOnly, selectedCallback, notApplicableLongMsg,
			notApplicableShortMsg, ratingClasses, ratingMsgs, clickHereMsg) {

		var selectedRating = null;

		if (!readOnly) {
			element.find('[data-value=-1]').click(selectNA);
			if ('ontouchstart' in document.documentElement) {
				element.find('li').click(selectCurrRating);
			} else {
				element.find('li').mouseover(activateHoverColoring);
				element.find('li').click(selectCurrRating);
				element.find('li').mouseleave(renderSelectedRating);
			}
		}

		if (initValue) {
			selectRating(initValue);
		}

		function selectCurrRating() {
			var currRating = $(this).data('value');
			selectRating(currRating);
		}

		function selectRating(newRating) {

			// read value including clean up possibility
			element.find('li').removeClass('is-selected');
			if (newRating == selectedRating) {
				selectedRating = null;
			} else {
				selectedRating = newRating;
				element.find('[data-value=' + newRating+ ']').addClass('is-selected');
			}

			if (isNA(element)) {
				toggleNA(element);
			}

			// update UI
			renderSelectedRating();
			selectedCallback && selectedCallback(selectedRating);
		}

		function selectNA() {
			if (isNA(element)) {
				selectedRating = null;
			} else {
				selectedRating = '-1';
			}

			element.find('li').removeClass('is-selected');
			cleanRating();
			toggleNA(element);
			selectedCallback && selectedCallback(selectedRating);
		}

		function activateHoverColoring() {
			var currRating = $(this).data('value');

			markRatingAndDescription(currRating, notApplicableLongMsg, notApplicableShortMsg);
		}

		function renderSelectedRating() {
			if (selectedRating) {
				markRatingAndDescription(selectedRating, notApplicableLongMsg, notApplicableShortMsg);
			} else {
				cleanRating();
			}
		}

		function markRatingAndDescription(rating, notApplicableLongMsg, notApplicableShortMsg) {
			markRating(element, rating, maxValue, notApplicableLongMsg, notApplicableShortMsg);
		}

		function cleanRating() {
			element.find('li').removeClass('is-active');

			element.find('.rating').removeClass('rating-neg rating-pos rating-neu rating-none');

			element.find('.rating-label-max').html(clickHereMsg);
		}

		function markRating(element, rating, maxValue, notApplicableLongMsg, notApplicableShortMsg) {
			cleanRating();

			var ratingInt = parseInt(rating);

			for (var i = 0; i < ratingInt; i++) {
				element.find('[data-value=' + (i + 1) + ']').addClass('is-active');
			}
			element.find('.rating-label-max').html(ratingMsgs[rating]);

			element.find('.rating').addClass(ratingClasses[rating]);

			if (isNA(element)) {
				element.find('.rating').addClass(ratingClasses['-1']);
			}
		}

		function isNA(element) {
			return element.find('[data-value=-1]').find('i.ty-icon').hasClass('ty-icon-checkbox-on');
		}

		function toggleNA(element) {
			if (isNA(element)) {
				element.find('[data-value=-1]').find('i.ty-icon').removeClass('ty-icon-checkbox-on').addClass('ty-icon-checkbox');
			} else {
				element.find('[data-value=-1]').find('i.ty-icon').removeClass('ty-icon-checkbox').addClass('ty-icon-checkbox-on');
				element.find('.rating-label-max').html(notApplicableLongMsg);
				element.find('.rating').addClass(ratingClasses['-1']);
			}
		}
	}

	$.fn.extend({

		/**
		 * Creates rating component on current DOM element. See the plugin docu
		 * above for settings object documention.
		 */
		tyRating: function(settings) {

			var settings = $.extend({}, defaultSettings, settings);

            var ratingClasses = generateClasses(settings.maxValue,
			    settings.ratingClasses, settings.componentColors);

			return this.each(function() {
				var currElement = $(this);
				generateContent(currElement, settings);
				activateContent(currElement, settings.initValue, settings.maxValue,
					settings.readOnly, settings.selectedCallback, settings.notApplicableLongMsg,
					settings.notApplicableShortMsg, ratingClasses, settings.ratingMsgs, settings.clickHereMsg);
			});

		}
	});

})(jQuery);
